// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-items-label {
  font-weight: 50;
  font-style: italic;
  font-size: clamp(0.5rem, 0.75vw, 1.3rem);
}

.tree-label {
  font-size: clamp(0.5rem, 0.9vw, 1.3rem);
  margin: 0;
}

.tree-icon {
  width: clamp(0.5rem, 1.1vw, 1.3rem);
  height: clamp(0.5rem, 1.1vw, 1.3rem);
  margin: 0 0.5rem 0 0;
}

.tree-item {
  display: flex;
  align-items: center;
  --min-height: clamp(1rem, 2.2vw, 2.6rem);
  --max-height: clamp(1rem, 2.2vw, 2.6rem);
  width: 100%;
}

.tree-checkbox {
  width: clamp(1.5rem, 3vw, 5rem);
  height: clamp(0.5rem, 1.1vw, 1.3rem);
  margin: 0.5rem 0 0.5rem 0.5rem;
}

.search-bar {
  padding: 0.3rem;
}
.search-bar ion-searchbar {
  --height: clamp(1.5rem, 3vw, 2.4rem);
  --min-height: clamp(1.5rem, 3vw, 2.4rem);
  padding: 0;
  margin: 0;
}

::ng-deep .searchbar-input.sc-ion-searchbar-ios {
  font-size: clamp(0.5rem, 0.9vw, 1.3rem);
  padding: 0 8px;
}

::ng-deep .search-bar.sc-ion-searchbar-ios-h,
::ng-deep ion-searchbar.search-bar.sc-ion-searchbar-ios-h {
  min-height: 10px !important;
  --min-height: 10px !important;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/directory-tree/directory-tree.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,wCAAA;AACJ;;AAEA;EACI,uCAAA;EACA,SAAA;AACJ;;AAEA;EACI,mCAAA;EACA,oCAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,wCAAA;EACA,WAAA;AACJ;;AAEA;EACI,+BAAA;EACA,oCAAA;EACA,8BAAA;AACJ;;AAGA;EACI,eAAA;AAAJ;AAEI;EACI,oCAAA;EACA,wCAAA;EACA,UAAA;EACA,SAAA;AAAR;;AAIA;EACI,uCAAA;EACA,cAAA;AADJ;;AAKI;;EAEE,2BAAA;EACA,6BAAA;EACA,aAAA;AAFN","sourcesContent":[".no-items-label {\r\n    font-weight: 50; \r\n    font-style: italic;\r\n    font-size: clamp(0.5rem, 0.75vw, 1.3rem)\r\n}\r\n\r\n.tree-label {\r\n    font-size: clamp(0.5rem, 0.9vw, 1.3rem);\r\n    margin: 0;\r\n}\r\n\r\n.tree-icon {\r\n    width: clamp(0.5rem, 1.1vw, 1.3rem);\r\n    height: clamp(0.5rem, 1.1vw, 1.3rem);\r\n    margin: 0 0.5rem 0 0;\r\n}\r\n\r\n.tree-item {\r\n    display: flex;\r\n    align-items: center;\r\n    --min-height: clamp(1rem, 2.2vw, 2.6rem);\r\n    --max-height: clamp(1rem, 2.2vw, 2.6rem);\r\n    width: 100%;\r\n}\r\n\r\n.tree-checkbox {\r\n    width: clamp(1.5rem, 3vw, 5rem);\r\n    height: clamp(0.5rem, 1.1vw, 1.3rem);\r\n    margin: 0.5rem 0 0.5rem 0.5rem;\r\n    \r\n}\r\n\r\n.search-bar {\r\n    padding: 0.3rem;\r\n\r\n    ion-searchbar {\r\n        --height: clamp(1.5rem, 3vw, 2.4rem);\r\n        --min-height: clamp(1.5rem, 3vw, 2.4rem);\r\n        padding: 0;\r\n        margin: 0;\r\n      }\r\n}\r\n\r\n::ng-deep .searchbar-input.sc-ion-searchbar-ios {\r\n    font-size: clamp(0.5rem, 0.9vw, 1.3rem);\r\n    padding: 0 8px;\r\n}\r\n\r\n::ng-deep {\r\n    .search-bar.sc-ion-searchbar-ios-h,\r\n    ion-searchbar.search-bar.sc-ion-searchbar-ios-h {\r\n      min-height: 10px !important; // Change to your desired height\r\n      --min-height: 10px !important;\r\n      padding: 10px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
